import { PERMISSIONS } from '@repo/contracts';
import type { NavItem } from '@repo/ui';
import { FileSignature, FileText, Mail, UserCog, Workflow } from 'lucide-react';

import { ADMIN_PATHS } from './admin-paths';

/** Each item follows its own read permission, so the group shows to anyone who holds any of them. */
export const ADMIN_NAV_ITEMS: NavItem[] = [
  {
    to: ADMIN_PATHS.workflows.list,
    label: 'Workflows',
    icon: Workflow,
    permission: PERMISSIONS.workflowRead,
    group: 'Administration',
  },
  {
    to: ADMIN_PATHS.forms.list,
    label: 'Forms',
    icon: FileText,
    permission: PERMISSIONS.formTemplateRead,
    group: 'Administration',
  },
  {
    to: ADMIN_PATHS.signing.list,
    label: 'Signing templates',
    icon: FileSignature,
    permission: PERMISSIONS.formTemplateRead,
    group: 'Administration',
  },
  {
    to: ADMIN_PATHS.emails.list,
    label: 'Emails',
    icon: Mail,
    permission: PERMISSIONS.emailTemplateRead,
    group: 'Administration',
  },
  {
    to: ADMIN_PATHS.directNdaSettings,
    label: 'Direct NDA signer',
    icon: UserCog,
    permission: PERMISSIONS.directNdaSettingsUpdate,
    group: 'Administration',
  },
];
